import { ECommerceApi } from '@itsrever/rever-api'
import { axiosInstance } from './apiConfiguration'

export const ecommerceApi = new ECommerceApi(
    undefined,
    undefined,
    axiosInstance
)
